"use client";

import { useRef } from "react";
import Image from "next/image";
import ActivityCard from "@/components/page/DoiSongSinhVien/ActivityCard/ActivityCard";

interface Activity {
  id: string;
  slug: string;
  title: string;
  description: string;
  image: string;
  badge: string;
  badgeType: "primary" | "secondary";
  icon: string;
}

interface Props {
  activities: Activity[];
}

export default function ActivitiesCarousel({ activities }: Props) {
  const trackRef = useRef<HTMLDivElement>(null);

  const scrollByCard = (direction: "prev" | "next") => {
    if (!trackRef.current) return;

    const firstCard = trackRef.current.querySelector(".activity-card") as HTMLElement | null;
    const step = (firstCard?.offsetWidth ?? trackRef.current.clientWidth) + 17;

    trackRef.current.scrollBy({
      left: direction === "next" ? step : -step,
      behavior: "smooth",
    });
  };

  return (
    <section className="activities-carousel">
      <div className="container">
        <div className="student-life-header__content">
          <div className="student-life-header__text">
            <span className="student-life-header__category">HOẠT ĐỘNG</span>
            <h1 className="student-life-header__title">Học Tập & Rèn Luyện</h1>
          </div>
          <div className="student-life-header__controls">
            <button
              className="carousel-nav carousel-nav--prev"
              type="button"
              aria-label="Previous slide"
              onClick={() => scrollByCard("prev")}
            >
              <Image src="/assets/svg/arrow-left.svg" alt="Previous" width={25} height={25} />
            </button>
            <button
              className="carousel-nav carousel-nav--next"
              type="button"
              aria-label="Next slide"
              onClick={() => scrollByCard("next")}
            >
              <Image src="/assets/svg/arrow-right.svg" alt="Next" width={25} height={25} />
            </button>
          </div>
        </div>

        <div ref={trackRef} className="activities-carousel__track">
          {activities.map((activity) => (
            <ActivityCard key={activity.id} activity={activity} />
          ))}
        </div>

        <nav className="activities-slider-nav d-sm-none" aria-label="Điều hướng slider">
          <button
            className="activities-slider-nav__btn activities-slider-nav__btn--prev"
            type="button"
            aria-label="Slide trước"
            onClick={() => scrollByCard("prev")}
          >
            <Image src="/assets/svg/d-arrow-left.svg" alt="" width={11} height={10} loading="lazy" />
          </button>
          <button
            className="activities-slider-nav__btn activities-slider-nav__btn--next"
            type="button"
            aria-label="Slide sau"
            onClick={() => scrollByCard("next")}
          >
            <Image src="/assets/svg/d-arrow-right.svg" alt="" width={11} height={10} loading="lazy" />
          </button>
        </nav>
      </div>
    </section>
  );
}
